/*
 * LES ROUTES, EN TROIS MORCEAUX — ET RIEN A CHANGER AILLEURS.
 *
 * Ce fichier a franchi les 500 lignes en accueillant `/price-suggestions`.
 * Plutot que de le laisser grossir, il devient un assemblage :
 * `import { routes } from './app.routes'` continue de fonctionner tel quel.
 *
 * LE DECOUPAGE SUIT LES MODULES METIER, pas un comptage. Comptabilite et
 * ressources humaines ont chacune leur `moduleGuard`, leur domaine de
 * permissions et leur rythme propre ; le reste est le tronc commun.
 *
 * L'ORDRE DE CONCATENATION EST SIGNIFIANT. Angular resout dans l'ordre de
 * declaration, et une route litterale doit preceder la route parametree qui
 * l'avalerait — `purchase-orders/new` avant `purchase-orders/:id/edit`. Les
 * trois blocs conservent l'ordre du fichier d'origine ; ne pas les permuter.
 */
import { Routes } from '@angular/router';
import { routesExploitation } from './routes/routes-exploitation';
import { routesComptabilite } from './routes/routes-comptabilite';
import { routesRh } from './routes/routes-rh';

export const routes: Routes = [
  ...routesExploitation,
  ...routesComptabilite,
  ...routesRh,
];
